export default __webpack_public_path__ + "static/media/headsetbg.a1272de8.svg";